<template>
  <div></div> <!-- Empty div as this page is just for redirection -->
</template>

<script>
import Nav from "../App.vue"; // Import Nav (which is actually App.vue) to use its methods

export default {
  name: "RedirectToLogin",

  created() {
    if (!this.$auth.isAuthenticated) {
      // If not authenticated, use the login method from App.vue
      Nav.methods.login.call(this);
    } else {
      // If already authenticated, use Vue Router to navigate to the homepage
      this.$router.push('/');
    }
  }
};
</script>